module.exports = __webpack_public_path__ + "static/media/main-desktop-background.d3263e83.jpg";